import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-dom-object-type-menu',
  templateUrl: './dom-object-type-menu.component.html',
  styleUrls: ['./dom-object-type-menu.component.css']
})
export class DomObjectTypeMenuComponent implements OnInit {
    domObjectTypeKeyno;

    public menu?: Menu;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.domObjectTypeKeyno = this.stateService.getStateParams()['domobjecttype_keyno'];
    }

    private async loadMenu() {
        if (!!this.domObjectTypeKeyno) {
            this.menu = (await this.datatask.Post(3017, { domobjecttype_keyno: this.domObjectTypeKeyno }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_domobjecttypemenu_domobjecttypeprop_grid')
                .setLoadDataFunction({
                    method: 3021,
                    parameters: { domobjecttype_keyno: this.menu?.domobjecttype_keyno }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'domobjecttypemenu_new',
                    text: 'domobjecttypemenu_new',
                    func: () => {
                        this.stateService?.go('domobjecttypeprop', {
                            domobjecttype_keyno: this.menu?.domobjecttype_keyno,
                            domobjecttypeprop_keyno: '0'
                        })
                    },
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    domobjecttype_keyno: number;
    domobjecttype_name: string;
    reg_datetime: string;
    reg_by_portal_user_keyno: string;
    domobjecttypetype_id: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('domObjectTypeMenu', {
//        templateUrl: 'views/components/views/domObjectTypeMenu/domObjectTypeMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'domObjectTypeMenuService', 'ttGridFactory', function ($stateParams, stateService, domObjectTypeMenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let domObjectTypeKeyno = $stateParams.domobjecttype_keyno;

//            vm.model = {
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_domobjecttypemenu_domobjecttypeprop_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'domobjecttypemenu_new',
//                    text: 'domobjecttypemenu_new',
//                    func: () => {
//                        stateService.go('domobjecttypeprop', {
//                            domobjecttype_keyno: vm.model.menu.domobjecttype_keyno,
//                            domobjecttypeprop_keyno: '0'
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await domObjectTypeMenuService.getDomObjectTypeMenu({ domobjecttype_keyno: domObjectTypeKeyno }))[0];

//                return loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3021,
//                    parameters: { domobjecttype_keyno: vm.model.menu.domobjecttype_keyno }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
